import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Container, Col, CardBody } from 'reactstrap';
import { connect } from 'react-redux';
import ReactRouterPropTypes from 'react-router-prop-types';
import columns from './components/Columns';
import Modal from '../../shared/components/Modal';
import MatTable from '../../shared/components/material-table';
import { DEFAULT_PAGE_SIZE } from '../../shared/utils/constants';
import {
  questionFindAllQuery,
  removeQuestionMutation,
} from '../../shared/queries/QuestionDatabase';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';

import GraphQL from '../../GraphQL';

const QuestionDatabase = (props) => {
  const { t, dispatch, history } = props;
  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [selectedDto, setSelectedDto] = useState({});

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  const toggleModal = () => {
    setModal(!modal);
  };

  const loadData = () => {
    showLoading();
    const query = questionFindAllQuery();
    GraphQL(query, {})
      .then((res) => {
        res.questionFindAll = res.questionFindAll.map((item) => ({
          ...item,
          activeDescription: t(`general.yesno.${item.active}`),
          typeDescription: t(`question.type-description.${item.type}`),
        }));
        setData(res.questionFindAll);
        hideLoading();
      })
      .catch((error) => {
        hideLoading();
        console.error(error);
      });
  };

  const removeItemClickHandler = (evt, rowData) => {
    setSelectedDto({
      ...rowData,
    });
    toggleModal();
  };

  const addItemClickHandler = () => {
    history.push('/minime/banco-questoes/mnt/0');
  };

  const editItemClickHandler = (evt, rowData) => {
    history.push(`/minime/banco-questoes/mnt/${rowData.id}`);
  };

  const deleteItem = () => {
    toggleModal();
    showLoading();
    const removeMutation = removeQuestionMutation(selectedDto.id);
    GraphQL(removeMutation, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-removed')
        );
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-remove')
        );
      })
      .finally(() => {
        hideLoading();
        loadData();
      });
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <Fragment>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('notifications.delete_modal')}
        toggle={toggleModal}
        modal={modal}
        onConfirm={deleteItem}
      />
      <Container>
        <Col className="Table">
          <CardBody>
            <div className="material-table__wrap">
              <MatTable
                data={data}
                columns={columns(t)}
                pageSize={DEFAULT_PAGE_SIZE}
                deleteAction={toggleModal}
                onRefreshClick={loadData}
                onAddClick={addItemClickHandler}
                onEditClick={editItemClickHandler}
                onRemoveClick={removeItemClickHandler}
                title={t('panels.banco-questoes')}
              />
            </div>
          </CardBody>
        </Col>
      </Container>
    </Fragment>
  );
};

QuestionDatabase.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(QuestionDatabase)
);
